<template>
  <router-view />
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai+Looped&display=swap');

* {
  font-family: "Noto Sans Thai Looped", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.form-control::placeholder {
  font-family: "Noto Sans Thai Looped", sans-serif;
  font-weight: 400;
  font-style: normal;
}

a {
  text-decoration: none !important;
}
</style>
